/**
 * creates a wrapper div with the expected class name for the widget
 * and the `manifold` class name.
 *
 * @dev this specific selector is used to scope the TW preflight styles to the widget.
 *      any changes to the classnames should be reflected in the tailwind.config.ts file.
 */
export default function WidgetWrapper({
  widgetTag,
  children,
}: {
  widgetTag: string;
  children: React.ReactNode;
}) {
  return <div className={widgetTag + ' manifold'}>{children}</div>;
}
